import React from 'react';
import { TableRow, TableCell } from '@mui/material';

const FullUsageItem = ({
  id,
  costCenter,
  user,
  date,
  time,
  phone,
  type,
  quantity,
  revenue,
  translation,
}) => (
  <TableRow>
    <TableCell>{id}</TableCell>
    <TableCell>{costCenter}</TableCell>
    <TableCell>{user}</TableCell>
    <TableCell sx={{ whiteSpace: 'nowrap' }}>{date}</TableCell>
    <TableCell>{time}</TableCell>
    <TableCell>{phone}</TableCell>
    <TableCell>
      {type} {translation && `(${translation})`}
    </TableCell>
    <TableCell>{quantity}</TableCell>
    <TableCell>{revenue}</TableCell>
  </TableRow>
);

export default FullUsageItem;
